import React from 'react'

import { DataGrid, TColumnDef, Typography } from '@pnld/components-web'

import { IData, ITableProps } from './types'

const stagesMap = {
  educacaoInfantil: 'Educação Infantil',
  ensinoFundamental: 'Ensino Fundamental',
  ensinoMedio: 'Ensino Médio',
  cursoTecnico: 'Curso Técnico',
  eja: 'EJA',
}

const StagesTable: React.FC<ITableProps> = ({ id, data }) => {
  const columns: Array<TColumnDef<IData>> = [
    {
      accessorKey: 'stage',
      header: `Etapas de ensino - ${stagesMap[id] || ''}`,
      cell: ({ row }) => (
        <Typography variant="b-sm" color="brand.neutral.dark_2">
          {row.original.stage}
        </Typography>
      ),
    },
    {
      id: 'total',
      cell: ({ row }) =>
        row.original.isTotal ? (
          <Typography
            variant="b-sm"
            color="brand.neutral.dark_2"
            sx={{ fontWeight: 'bold' }}
          >
            Total
          </Typography>
        ) : null,
    },
    {
      accessorKey: 'census',
      header: 'Censo',
      cell: ({ row }) => (
        <Typography
          variant="b-sm"
          color="brand.neutral.dark_2"
          sx={{ fontWeight: row.original.isTotal ? 'bold' : 'normal' }}
        >
          {row.original.census.toLocaleString('pt-BR')}
        </Typography>
      ),
    },
    {
      accessorKey: 'h1',
      header: 'QT1',
      cell: ({ row }) => (
        <Typography
          variant="b-sm"
          color="brand.neutral.dark_2"
          sx={{ fontWeight: row.original.isTotal ? 'bold' : 'normal' }}
        >
          {row.original.h1.toLocaleString('pt-BR')}
        </Typography>
      ),
    },
    {
      accessorKey: 'h2',
      header: 'QT2',
      cell: ({ row }) => (
        <Typography
          variant="b-sm"
          color="brand.neutral.dark_2"
          sx={{ fontWeight: row.original.isTotal ? 'bold' : 'normal' }}
        >
          {row.original.h2.toLocaleString('pt-BR')}
        </Typography>
      ),
    },
  ]

  return <DataGrid columns={columns} data={data} hasPagination={false} />
}

export default StagesTable
